import { OrgBaseInterface } from "../Shared/OrgBase.Interace";
import { InheritanceStatus, Slug } from "../Shared/Shared.Interfaces";

export enum BrainType {
  CLU = "CLU", // Cognitive Learning Unit
  NLP = "NLP",
  LLM = "LLM"
}

export interface BrainInterfaceInternal extends BrainInterface {
  id: number;
}

export interface BrainInterface extends OrgBaseInterface {
  slug: Slug;
  name: string;

  type: BrainType;
  inheritance?: InheritanceStatus;
  data: any;
  model: any;
}

export interface NLPBrainModel {
  appId: string;
  version: string;
}
export interface CLUBrainModel {
  projectName: string;
  deploymentName: string;
}

export interface LLMModel {
  model: "text-davinci-003" | "gpt-3.5-turbo" | "gpt-4" | "gpt-4.1";
}
export interface LLMData {
  prompt: string;
  numberOfMessagesToInclude: number;
  numberOfTokensInResponse: number;
}

export interface NLPBrainInterface extends BrainInterface {
  type: BrainType.NLP;
  data: NLPBrainData;
  model: NLPBrainModel;
}
export interface CLUBrainInterface extends BrainInterface {
  type: BrainType.CLU;
  data: NLPBrainData;
  model: CLUBrainModel;
}

export interface LLMBrainInterface extends BrainInterface {
  type: BrainType.LLM;
  data: LLMData;
  model: LLMModel;
}

export function isNLPBrain(brain: BrainInterface): brain is NLPBrainInterface {
  return brain.type === BrainType.NLP;
}

export function isLLMBrain(brain: BrainInterface): brain is NLPBrainInterface {
  return brain.type === BrainType.LLM;
}
export enum NLPBrainActionType {
  // DEFAULT = 'default',
  QUEST = "quest",
  BRAIN = "brain"
}
export interface NLPBrainAction {
  type: NLPBrainActionType;
  intent?: string;
  active?: boolean;
  goto?: Slug;
}
export interface NLPBrainThresholds {
  intent: number;
  entity: number;
}

export interface NLPBrainData {
  actions: { [intent: string]: NLPBrainAction };
  unhandled: NLPBrainAction;
  thresholds: NLPBrainThresholds;
}
